import React from 'react';
import PropTypes from 'prop-types';
import { useAccountOrMembershipRequiredModalContext } from '../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';
import ListAssignDrawer from '../CollaborativeLists/ManageFromTitleOrList/ListAssignDrawer';
import { useShelves } from '../Shelves/containers/ShelvesDataStore';
import ShelfSelectDrawer from '../Shelves/Selection/ShelfSelectDrawer';
import ShelfType from '../Shelves/ShelfType';
import LaneContainer from '../UI/LaneContainer';
import { useUser } from '../User/containers/UserDataStore';
import { useTitle } from './containers/TitleDataStore';

TitleYourLists.propTypes = {
	sku: PropTypes.string,
};

export default function TitleYourLists({ sku }) {
	const { shelves } = useShelves();
	const {
		state: { collaborativeLists, isCollectionDataLoading, collections },
	} = useTitle();
	const { isAnonymous } = useUser();
	const { setIsVisible } = useAccountOrMembershipRequiredModalContext();

	const getShelfDisplay = () => {
		const selectedShelf =
			shelves &&
			shelves.length > 0 &&
			shelves.filter(sh => sh.sku === sku).length > 0
				? shelves.find(sh => sh.sku === sku).shelf
				: 0;
		if (selectedShelf === 0) {
			return (
				<span className="acc-font bold">Place title on a shelf</span>
			);
		} else {
			return (
				<React.Fragment>
					<span>On your </span>
					<span className="acc-font bold">
						{ShelfType[selectedShelf].text}
					</span>
					<span>&nbsp;shelf</span>
				</React.Fragment>
			);
		}
	};

	const renderShelfDisplay = () => {
		return (
			<React.Fragment>
				<div>&bull;&nbsp;{getShelfDisplay()}</div>
				<div>
					&bull;&nbsp;In{' '}
					<span className="acc-font bold">
						{!isCollectionDataLoading &&
						collections &&
						collections.filter(cl => cl.hasFlaggedTitle)
							? collections.filter(cl => cl.hasFlaggedTitle)
									.length
							: 0}
					</span>{' '}
					of your {collections && collections.length} Collections
				</div>
			</React.Fragment>
		);
	};

	return (
		<div>
			<LaneContainer majorHeader="Your Stacks" icon="books">
				{isAnonymous() ? (
					<div onClick={() => setIsVisible(true)}>
						{renderShelfDisplay()}
					</div>
				) : (
					<ShelfSelectDrawer sku={sku}>
						{renderShelfDisplay()}
					</ShelfSelectDrawer>
				)}
				<div style={{ marginBottom: '10px' }}>
					<ListAssignDrawer>
						&bull;&nbsp;In{' '}
						<span className="acc-font bold">
							{collaborativeLists.lists
								? collaborativeLists.lists.length
								: 0}{' '}
						</span>
						Collaborative Lists
					</ListAssignDrawer>
				</div>
			</LaneContainer>
		</div>
	);
}
